import { frontendURL } from '../../../helper/URLHelper';
import AreaQprecoIndex from './pages/AreaQprecoIndex.vue';
import { laisCanonicalRedirect } from '../laisRouteHelpers';

export const routes = [
  {
    path: frontendURL('accounts/:accountId/area-qpreco'),
    name: 'lais_area_qpreco_index',
    component: AreaQprecoIndex,
    meta: { permissions: ['administrator', 'agent'] },
  },
  {
    // Intermediate deep-link target: nobody navigates here in-app (the index
    // jumps straight to lais_area_qpreco_section), but external links to
    // /area-qpreco/:id must keep working. Redirect to the default section so
    // the detail view opens on its first tab instead of rendering an empty
    // section route.
    path: frontendURL('accounts/:accountId/area-qpreco/:id'),
    name: 'lais_area_qpreco_show',
    redirect: laisCanonicalRedirect('lais_area_qpreco_section', {
      params: { section: 'estimativa' },
    }),
    meta: { permissions: ['administrator', 'agent'] },
  },
  {
    path: frontendURL('accounts/:accountId/area-qpreco/:id/:section'),
    name: 'lais_area_qpreco_section',
    component: AreaQprecoIndex,
    meta: { permissions: ['administrator', 'agent'] },
  },
];
